import { create } from 'zustand';

import { createContactsSlice } from './actions';
import { ContactsStore } from './types';

export const useContactsStore = create<ContactsStore>()((set, get, store) => ({
  ...createContactsSlice(set, get, store),
}));

export * from './selectors';
export * from './types';
